// assets/calculator.js
document.addEventListener('DOMContentLoaded', function() {
  if (document.getElementById('calculateButton')) {
    const calculateButton = document.getElementById('calculateButton');
    calculateButton.addEventListener('click', function() {
      const width = parseFloat(document.getElementById('wallWidth').value);
      const height = parseFloat(document.getElementById('wallHeight').value);
      
      if (isNaN(width) || isNaN(height)) {
        document.getElementById('calculationResult').innerHTML = 
          '<div class="result-text">Please enter valid measurements</div>';
        return;
      }
      
      const widthCm = width * 2.54;
      const heightCm = height * 2.54;
      const wallArea = widthCm * heightCm;
      const rollArea = 70 * 1000;
      const rollsNeeded = Math.ceil((wallArea / rollArea) * 1.1);
      
      document.getElementById('calculationResult').innerHTML = `
        <div class="result-text">Rolls needed: ${rollsNeeded}</div>
        <div class="note">*Includes 10% waste</div>
      `;
    });
  }
});